import i18n from "i18next";
import { translation as translation_vi } from "./locale/vi";
import { translation as translation_en } from "./locale/en";
import { initReactI18next } from "react-i18next";

const resources = {
  vi: {
    translation: translation_vi,
  },
  en: {
    translation: translation_en,
  },
};

const lang = localStorage.getItem("lang");
const defaultLang = lang === "en" ? "en-US" : "vi-VN";

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: defaultLang,
  lng: lang,
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
